<mat-card>
  <app-card-header title="Add Protocol"></app-card-header>
    <mat-card-content class="p-3">

      <!-- Only shows in local/QA -->
      <button mat-raised-button
              color="accent"
              (click)="autofill()"
              *ngIf="showAutofillButton">
        Autofill
      </button>

      <form [formGroup]="form">

        <!-- Previous IRB Number -->
        <div *ngIf="model.previousIrbNumber" class="mb-2">
          <span class="mat-h4">Previous IRB Number: </span><span>{{ model.previousIrbNumber }}</span>
        </div>

        <!-- Protocol Details -->
        <div class="form-section mat-elevation-z4">Protocol Details</div>

        <div class="row">
          <div class="col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Study Title</mat-label>
              <input matInput formControlName="studyTitle" required>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>IRBNet Number</mat-label>
              <input matInput formControlName="irbNetNumber" maxlength="250">
            </mat-form-field>
          </div>
          <div class="col-md-4 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Status</mat-label>
              <mat-select formControlName="statusId">
                <mat-option *ngFor="let option of statusOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-4 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Funding Agency</mat-label>
              <mat-select formControlName="fundingAgencyId">
                <mat-option *ngFor="let option of fundingAgency$ | async" [value]="option.id">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Nature of Research</mat-label>
              <mat-select formControlName="natureOfResearchId">
                <mat-option *ngFor="let option of natureOfResearch$ | async" [value]="option.id">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-4 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Type of Research</mat-label>
              <mat-select formControlName="typeOfResearchId">
                <mat-option *ngFor="let option of researchTypeOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-4 col-sm-12" *ngIf="form.get('typeOfResearchId')?.value === sponsoredResearchTypeId">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Type of Sponsored Clinical Trial (Drug/Device/Biologic)</mat-label>
              <mat-select formControlName="sponsoredClinicalTrialId">
                <mat-option *ngFor="let option of sponsoredClinicalTrial$ | async" [value]="option.id">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- Ownership -->
        <div class="form-section mat-elevation-z4">Ownership</div>

        <div class="row">
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Investigator</mat-label>
              <mat-select formControlName="investigatorId">
                <mat-option *ngFor="let option of investigatorOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Co-Investigator</mat-label>
              <input matInput formControlName="coInvestigator" maxlength="250">
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>NTRIRB Coordinator</mat-label>
              <mat-select formControlName="ntrIrbCoordinatorId">
                <mat-option *ngFor="let option of ntrCoordinatorOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>CR Coordinator</mat-label>
              <input matInput formControlName="crCoordinator" maxlength="250">
            </mat-form-field>
          </div>

        </div>

        <div class="row">
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Department</mat-label>
              <mat-select formControlName="departmentId">
                <mat-option *ngFor="let option of departmentOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>School</mat-label>
              <mat-select formControlName="schoolId">
                <mat-option *ngFor="let option of schoolOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        
        </div>
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Institution</mat-label>
              <mat-select formControlName="institutionId">
                <mat-option *ngFor="let option of institutionOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Collaborating Institution</mat-label>
              <mat-select formControlName="collaboratingInstitutionId">
                <mat-option *ngFor="let option of collaboratingInstitutionOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- Sponsorship -->
        <div class="form-section mat-elevation-z4">Sponsorship</div>
        <div formArrayName="sponsorTypeCategories">
          <div class="row mb-2" *ngFor="let group of sponsorTypeCategoriesForm.controls; let i = index" [formGroupName]="i">
            <div class="col-md-3 col-sm-12">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>Sponsor Type</mat-label>
                <mat-select formControlName="categoryId" (selectionChange)="onSponsorTypeChange(i)">
                  <mat-option *ngFor="let type of sponsorTypeOptions$ | async" [value]="type.id">{{ type.name }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-3 col-sm-12">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>Sponsor</mat-label>
                <mat-select formControlName="subCategoryId" [disabled]="!sponsorTypeCategoriesForm.at(i).get('categoryId')?.value">
                  <mat-option *ngFor="let sponsor of filteredSponsors[i] || []" [value]="sponsor.id">{{ sponsor.name }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-4 col-sm-12">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>Sponsor Protocol</mat-label>
                <input matInput formControlName="sponsorProtocol" maxlength="250">
              </mat-form-field>
            </div>

            <div class="col-md-2 d-flex align-items-center">
              <button *ngIf="i != 0" mat-icon-button color="warn" (click)="removeSponsorTypeCategory(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <button mat-stroked-button color="primary" (click)="addSponsorTypeCategory()">Add Sponsor</button>

        <!-- Review -->
        <div class="form-section mat-elevation-z4">Review</div>

        <div class="row">
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Type of Review</mat-label>
              <mat-select formControlName="typeOfReviewId">
                <mat-option *ngFor="let option of reviewTypeOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Review Cycle</mat-label>
              <mat-select formControlName="reviewCycleId">
                <mat-option *ngFor="let option of reviewCycleOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row" *ngIf="form.get('typeOfReviewId')?.value === cededReviewTypeId">
          <div class="col-md-6 col-sm-12">
       
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>IRB of Record</mat-label>
                <mat-select formControlName="irbofRecordId">
                  <mat-option *ngFor="let option of irbofRecords$ | async" [value]="option.id">{{ option.name }}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('irbofRecordId')?.hasError('required')">
                  IRB of Record is required when Type of Review is Ceded.
                </mat-error>
              </mat-form-field>
           
          </div>
        </div>

        <!-- Special Findings -->
        <div class="form-section mat-elevation-z4">Special Findings</div>

        <div class="row">
          <div class="col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Special Findings Category</mat-label>
              <mat-select formControlName="specialFindingCategories" multiple>
                <mat-option *ngFor="let option of specialFindingOptions$ | async" [value]="option.id">
                  {{ option.name }}
                </mat-option>
              </mat-select>

            </mat-form-field>

          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Special Findings Notes</mat-label>
              <textarea matInput formControlName="specialFindings" rows="5"></textarea>
            </mat-form-field>
          </div>
        </div>

        <!-- Milestones -->
        <div class="form-section mat-elevation-z4">Milestones</div>

        <div class="mt-3 mb-3">
          <span>All dates must occur after the initial submission date.</span>
        </div>

        <div class="row">
          <div class="col-md-3" *ngFor="let dateField of dateFields">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>{{ dateField.label }}</mat-label>
              <input matInput [matDatepicker]="picker" [formControlName]="dateField.controlName">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="form.get(dateField.controlName)?.hasError('required')">
                {{ dateField.label }} is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>

      </form>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-stroked-button color="warn" (click)="cancel()">Cancel</button>
      <button mat-stroked-button color="accent" [disabled]="form.invalid || form.pristine" (click)="save()">Save</button>
    </mat-card-actions>
  </mat-card>
